import { getTextStylesFromBrandStyle, tryToGetBrandColorRefByHEX } from 'modules/BrandDefinition';
import { $verifyStyleForFont } from 'modules/Lexical/Plugins/FontBrandStylePlugin/brandStyle';
import * as Models from 'models';
import { createLexicalTextEditor } from '../../editors';
import { $matchBulletColor } from '../../Plugins/CustomListPlugin/utils';
import * as fontUtils from '../../Plugins/FontPlugin/utils';
import { $matchFontColor, $matchFontNameAndCharacterStyle } from '../../Plugins/FontPlugin/utils';
import * as textBlockUtils from '../../Plugins/TextBlockPlugin/utils';

/**
 * Saves applied styles everywhere if it's possible and applies brand styles where no chance to save applied styles
 * As a result, returns component with the updated lexical state
 */
export const matchAppliedStylesWithBrandStyleOnComponent = (
  textComponent: Models.TextComponent,
  brandStyle: Models.BrandStyleMap,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
): [Models.TextComponent, boolean] => {
  const { lexicalState } = textComponent;

  if (!lexicalState) {
    return [textComponent, false];
  }

  const {
    fontSize: brandFontSize,
    fontColor: brandFontColor,
    fontFamily: brandFontName,
    characterStyle: brandCharacterStyleName,
    lineHeight: brandLineHeight,
    textAlign: brandHorizontalAlignment,
    bulletColor: brandBulletColor,
  } = getTextStylesFromBrandStyle(brandStyle, colors, fonts);
  const brandFontColorStyle = tryToGetBrandColorRefByHEX(colors, brandFontColor);
  const brandBulletColorStyle = tryToGetBrandColorRefByHEX(colors, brandBulletColor);

  let brandStyleChanged = false;

  const editor = createLexicalTextEditor(lexicalState);
  editor.update(() => {
    // FONT SIZE
    fontUtils.$applyFontSizeToAllNodes(brandFontSize);

    // FONT COLOR
    const commonFontColorName = $matchFontColor(colors, brandFontColorStyle);
    brandStyleChanged = brandStyleChanged || (
      !commonFontColorName || commonFontColorName !== brandFontColorStyle.name
    );

    // BULLET COLOR
    const commonBulletColorName = $matchBulletColor(colors, brandBulletColorStyle);
    brandStyleChanged = brandStyleChanged || (
      !commonBulletColorName || commonBulletColorName !== brandBulletColorStyle.name
    );

    // LINE HEIGHT
    brandStyleChanged = brandStyleChanged || !textBlockUtils.$doAllNodesHaveLineHeight(brandLineHeight, true);

    // TEXT ALIGN
    brandStyleChanged = brandStyleChanged
      || !textBlockUtils.$doAllNodesHaveHorizontalAlignment(brandHorizontalAlignment);

    // FONT NAME
    const commonFontName = $matchFontNameAndCharacterStyle(
      fonts,
      brandFontName,
      brandCharacterStyleName,
    );
    brandStyleChanged = brandStyleChanged || (!commonFontName || commonFontName !== brandFontName);

    // CHARACTER STYLE
    brandStyleChanged = brandStyleChanged || (!!brandCharacterStyleName &&
        !fontUtils.$doAllNodesHaveBrandFontCharStyle(brandCharacterStyleName, true));

    // will adjust css related styles to the corresponding barnd colors and fonts
    $verifyStyleForFont(colors, fonts);
  }, { discrete: true });

  return [
    { ...textComponent, lexicalState: JSON.stringify(editor.getEditorState()) },
    brandStyleChanged,
  ];
};
